//Faz a alteração do texto Email US para Contact us no rodapé
$(document).ready(function(){
  let textSpan = $(".icon-email").next()[0]
  textSpan.innerText = 'Contact us'
})